<template>
	<v-layout>
		<v-flex xs12>
			<v-layout :wrap="$vuetify.breakpoint.smAndDown">
				<v-flex xs12 class="documents-display__toolbar">
					<v-toolbar flat dark height="35" color="secondary">
						<v-toolbar-title>{{title}}</v-toolbar-title>
						<v-spacer></v-spacer>
						<div v-if="type === 'Proposals'" class="documents-display__checkbox">
							<v-checkbox
								v-model="filtering.status"
								value="Not Sent"
								hide-details
								@change="filter"
								color="white"
								:ripple="false"
								label="Filter: Not Sent"
							></v-checkbox>
						</div>
					</v-toolbar>
				</v-flex>
				<v-flex v-if="filterable" xs12 sm6 md3 lg2 class="documents-display__sort">
					<v-select
						v-model="filtering"
						:items="filter_options"
						placeholder="Filter by Status"
						height="35"
						hide-details
						solo
						dense
						flat
						:class="!dark ? 'white' : ''"
						:color="dark ? 'tertiary' : ''"
						style="margin: 0; padding: 0"
						@change="filter"
						clearable
					></v-select>
				</v-flex>

				<v-flex v-if="sortable" xs12 sm6 md3 lg2 class="documents-display__sort">
					<v-select
						:items="sort_options"
						placeholder="Sort By"
						height="35"
						hide-details
						solo
						dense
						flat
						:class="!dark ? 'white' : ''"
						:color="dark ? 'tertiary' : ''"
						style="margin: 0; padding: 0"
						@change="sort"
						clearable
					></v-select>
				</v-flex>
				<v-flex xs12 sm6 md3 lg2 class="documents-display__filter">
					<v-menu
						ref="datepicker"
						v-model="datepicker"
						:close-on-content-click="false"
						:return-value="dates"
						transition="scale-transition"
						offset-y
						right
					>
						<v-combobox
							style="margin: 0; padding: 0"
							hide-details
							allow-overflow
							slot="activator"
							:value="formattedDates"
							multiple
							append-icon="event"
							height="35"
							solo
							flat
							placeholder="Filter By Date"
							readonly
							:class="!dark ? 'white' : ''"
							:color="dark ? 'tertiary' : ''"
						></v-combobox>
						<v-date-picker
							:value="dates"
							@input="changeDateRange"
							:scrollable="false"
							multiple
							no-title
							width="248"
							class="documents-display__date-picker"
						>
							<v-btn color="primary" @click="applyDates">Apply</v-btn>
							<v-spacer></v-spacer>
							<v-btn flat @click="resetDates">Reset Dates</v-btn>
						</v-date-picker>
					</v-menu>
				</v-flex>
			</v-layout>
			<v-item-group
				v-if="manager"
				v-model="user_ids"
				multiple
				class="layout reps-bar"
				@change="filter"
			>
				<v-flex
					@click="allUsers"
					:class="{ 'v-item--active': all_users }"
					class="reps-bar__toggle"
					shrink
				>
					<v-hover>
						<v-card flat color="transparent" slot-scope="{ hover }">
							<v-card-title>
								<v-avatar size="100" color="secondary">
									<div class="v-icon">
										<fa-icon :icon="['fal', 'users']" size="2x" fixed-width style="color: white" />
									</div>
								</v-avatar>
							</v-card-title>
							<v-btn
								round
								flat
								:outline="all_users"
								:class="{ 'success success--text': all_users, 'success--text': hover }"
							>All Reps</v-btn>
						</v-card>
					</v-hover>
				</v-flex>
				<v-item :value="user.id" class="reps-bar__toggle">
					<v-flex slot-scope="{ active, toggle }" @click="toggle" shrink>
						<v-hover>
							<v-card flat color="transparent" slot-scope="{ hover }">
								<v-card-title>
									<v-avatar size="100">
										<img :src="user.photo_url" :alt="user.name" />
									</v-avatar>
								</v-card-title>
								<v-btn
									round
									flat
									:outline="active"
									:class="{ 'success success--text': active, 'success--text': hover }"
								>You</v-btn>
							</v-card>
						</v-hover>
					</v-flex>
				</v-item>
				<v-item :value="user.id" v-for="user in USERS" :key="user.id" class="reps-bar__toggle">
					<v-flex slot-scope="{ active, toggle }" @click="toggle" shrink>
						<v-hover>
							<v-card flat color="transparent" slot-scope="{ hover }">
								<v-card-title>
									<v-avatar size="100">
										<img :src="user.photo_url" :alt="user.name" />
									</v-avatar>
								</v-card-title>
								<v-btn
									round
									flat
									:outline="active"
									:class="{ 'success success--text': active, 'success--text': hover }"
								>{{user.name}}</v-btn>
							</v-card>
						</v-hover>
					</v-flex>
				</v-item>
			</v-item-group>
		</v-flex>
	</v-layout>
</template>


<script>
import DocumentCard from "@components/partials/DocumentCard";
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";

export default {
	data: () => ({
		filter_options: [
			{
				text: "In Progress",
				value: {
					status: "In Progress"
				}
			},
			{
				text: "Not Sent",
				value: {
					status: "Not Sent"
				}
			},
			{
				text: "Sent to Customer",
				value: {
					status: "Sent to Customer"
				}
			},
			{
				text: "Ordered",
				value: {
					status: "Ordered"
				}
			},
			// {
			// 	text: "Proposals only",
			// 	value: {
			// 		type: "Proposal"
			// 	}
			// },
			{
				text: "Quotes only",
				value: {
					type: "Quote"
				}
			}
		],
		sort_options: [
			{
				text: "Date: Newest to Oldest",
				value: {
					orderby: "proposal_date",
					order: "desc"
				}
			},
			{
				text: "Date: Oldest to Newest",
				value: {
					orderby: "proposal_date",
					order: "asc"
				}
			},
			{
				text: "Quote Name A-Z",
				value: {
					orderby: "name",
					order: "asc"
				}
			},
			{
				text: "Quote Name Z-A",
				value: {
					orderby: "name",
					order: "desc"
				}
			},
			{
				text: "Quote Number",
				value: {
					orderby: "number",
					order: "asc"
				}
			}
		],
		user_ids: [],
		filtering: {},
		sorting: {
			orderby: "proposal_date",
			order: "desc"
		},
		dates: [],
		datepicker: false,
		page: 0
	}),

	props: {
		title: {
			default: ""
		},
		manager: {
			default: false
		},
		type: {
			default: null
		},
		sortable: {
			default: true
		},
		filterable: {
			default: true
		},

		initFilters: {
			default: null
		}
	},

	computed: {
		...mapGetters(["dark", "user"]),

		...mapGetters({
			USERS: "users"
		}),

		formattedDates() {
			let formatted = [];

			if (this.dates.length == 0) {
				return [];
			} else if (this.dates.length == 1) {
				return [moment(this.dates[0]).format("MMM D YYYY")];
			}

			let minDate = moment(_.min(this.dates)).format("MMM D YYYY");
			let maxDate = moment(_.max(this.dates)).format("MMM D YYYY");

			return [`${minDate} - ${maxDate}`];
		},

		filters() {
			let criteria = {};

			if (typeof this.filtering === "undefined") {
				this.filtering = {};
			}

			if (typeof this.sorting === "undefined") {
				this.sorting = {};
			}

			if (this.dates) {
				criteria.proposal_date = this.dates;
			}

			if (this.filtering.type) {
				criteria.type = this.filtering.type;
			}

			if (this.filtering.status) {
				criteria.status = this.filtering.status;
			}

			if (this.user_ids) {
				criteria.user_id = this.user_ids;
			}

			return {
				criteria,
				sorting: this.sorting
			};
		},

		all_users: {
			get() {
				return !this.user_ids.length;
			},

			set(value) {
				if (value) {
					this.user_ids = [];
				}
			}
		}
	},

	methods: {
		...mapActions({
			GET_USERS: "getUsers"
		}),

		// clearFilter() {
		// 	// console.log(this.filtering);

		// 	this.$set(this, "filtering", {});
		// 	this.filter();

		// 	// console.log(this.filtering);
		// },

		allUsers() {
			if (!this.all_users) {
				this.all_users = true;
				this.filter();
			}
		},

		changeDateRange(dates) {
			if (dates.length > 1) {
				let minDate = moment(_.min(dates));
				let maxDate = moment(_.max(dates));
				let difference = _.difference(this.dates, dates);
				let oldDates = dates;

				dates = [];

				if (difference.length) {
					maxDate = moment(_.min(difference));

					if (maxDate.isBefore(minDate)) {
						this.$set(this, "dates", [
							maxDate.format("YYYY-MM-DD")
						]);

						return;
					}
				}

				do {
					let date = minDate.format("YYYY-MM-DD");

					dates.push(date);

					minDate.add(1, "days");
				} while (minDate.isSameOrBefore(maxDate));
			}

			this.$set(this, "dates", _.uniq(dates));
		},

		applyDates() {
			this.datepicker = false;
			this.filter();
		},

		resetDates() {
			this.dates = [];
			this.filter();
		},

		sort(params) {
			this.$set(this, "sorting", params);
			this.$emit("sort", this.filters);
		},

		filter() {
			// console.log(this.filters);
			this.$emit("filter", this.filters);
		},

		filterNotSent() {
			let status = "Not Sent";

			if (this.filtering.status === status) {
				status = null;
			}

			this.$set(this.filtering, "status", status);
			this.filter();
		}
	},

	created() {
		if (this.manager) {
			this.GET_USERS({ manager: true });
		}

		if (this.initFilters) {
			_.forIn(this.initFilters, (value, key) => {
				this.$set(this.filtering, key, value);
			});

			this.filter();
		}
	}
};
</script>

